import type { PaginationState } from '@tanstack/react-table';

/**
 * What a pagination change from the table actually means to a server-paginated
 * caller.
 *
 * The table reports both values on every change and counts pages from zero,
 * while the API counts from one. Both of those are quiet failures if got wrong:
 * an off-by-one skips or repeats a page, and treating a size change as a page
 * change requests the old size at the new index.
 */
export type PaginationIntent =
  | { type: 'page'; page: number }
  | { type: 'size'; size: number };

export const paginationIntent = (
  next: PaginationState,
  currentPageSize: number,
): PaginationIntent =>
  next.pageSize !== currentPageSize
    ? { type: 'size', size: next.pageSize }
    : { type: 'page', page: next.pageIndex + 1 };
